import { Component, Input, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'mp-button',
  templateUrl: './button.html',
  styleUrls: ['./button.scss']
})
export class ButtonComponent {

  @Input() public buttonClass: string = 'btn-primary'
  @Input() public buttonText: string = 'Click Here'
  @Input() public disabled: boolean = false

  @Output() public onButtonClicked = new EventEmitter<any>()

  public onClickButton(event) {
      this.onButtonClicked.emit(event)
    }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/button/button.component.ts